import WinlosesTypes from './types';
import { BarWinlosesState, BarWinlosesDispatchAction } from './state';
import { Reducer } from 'redux';

const initialState: BarWinlosesState = {
    wins: '',
    loses: '',
    avg: 0,
    touch : 0,
    perfect : 0,
    chefmet : 0
}

export const WinlosesReducer : Reducer<BarWinlosesState, BarWinlosesDispatchAction>= 
    (state = initialState, action) => {
        switch(action.type) {
            case WinlosesTypes.FETCH_START:
                return state
            case WinlosesTypes.FETCH_SUCCESS:
                return action.payload
            default:
                return state
        }
    }

export default WinlosesReducer;